import React from 'react'
// import favicon from '../images/favicon.ico'
// import Helmet from 'react-helmet'
import {Link} from 'gatsby'
import Image from '../component/image'
import Menu from '../component/Menu'
import Seo from './seo'
const Header = (props) => {
  const { children, page } = props
  return(
    <React.Fragment>
      <Seo />
      {/* <Helmet>
        <link rel="icon" href={favicon} />
      </Helmet> */}
      <div className="header" role="banner">
        <div className={`${page ? page : ''} p-sm-4 pt-4`}>
          <div className="container-fluid">
            <div className='row pb-3'>
              <div className='col'>
                <nav className="navbar navbar-expand-lg navbar-dark px-0">
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse navigation" id="navbarsExampleDefault">
                    <Menu />
                  </div>
                </nav>
              </div>
              <div className='col'>
                <div className="logo mx-auto">
                  <Link to="/" className="d-block" >
                    <Image src="logo3.svg" alt="Omnidya" />
                  </Link>
                </div>
              </div>
              <div className='col text-right'>
                <button className="btn btn-gradient" type="button">
                  Sign Up
                </button>
              </div>
            </div>
            {children}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Header;
